import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="loading-screen">
        <div className="text-sm text-muted-foreground">Wird geladen …</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}
